import {
  FloatingPanel,
  FloatingPanelContent,
  FloatingPanelHeader,
  FloatingPanelSeparator,
  FloatingPanelTabs,
  FloatingPanelTabsContent,
  FloatingPanelTabsList,
  FloatingPanelTabsTrigger,
} from "@babackapp/ui/components/floating-panel";
import { PanelBlocksList } from "../panel-blocks-list";
import { VariablesDictionaryPanel } from "../variables-dictionary";
import { useFormContext } from "react-hook-form";
import type { EmailTemplateFormData } from "../../types";
import { useTranslation } from "react-i18next";

export default function LeftSidebarBlocksPanel() {
  const { t } = useTranslation("editor-blocks-library");
  const form = useFormContext<EmailTemplateFormData>();
  const templateType = form.watch("type");

  return (
    <FloatingPanel>
      <FloatingPanelTabs defaultValue="blocks">
        <FloatingPanelHeader className="py-1">
          <FloatingPanelTabsList>
            <FloatingPanelTabsTrigger value="blocks">
              {t("editorBlocksLibrary.leftSidebar.blocks.title", "Blocks")}
            </FloatingPanelTabsTrigger>
            <FloatingPanelTabsTrigger value="variables">
              {t(
                "editorBlocksLibrary.leftSidebar.variables.title",
                "Variables",
              )}
            </FloatingPanelTabsTrigger>
          </FloatingPanelTabsList>
        </FloatingPanelHeader>
        <FloatingPanelSeparator />

        <FloatingPanelContent className="px-0 py-0">
          <FloatingPanelTabsContent value="variables">
            <VariablesDictionaryPanel />
          </FloatingPanelTabsContent>
          <FloatingPanelTabsContent value="blocks">
            <PanelBlocksList templateType={templateType} />
          </FloatingPanelTabsContent>
        </FloatingPanelContent>
      </FloatingPanelTabs>
    </FloatingPanel>
  );
}
